import { render, staticRenderFns } from "./v-search.vue?vue&type=template&id=f19e2e10&scoped=true&"
import script from "./v-search.vue?vue&type=script&lang=ts&"
export * from "./v-search.vue?vue&type=script&lang=ts&"
import style0 from "./v-search.vue?vue&type=style&index=0&id=f19e2e10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f19e2e10",
  null
  
)

export default component.exports